import React, { Component } from "react";
import { Table, Button, Row, Col } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class MonitorProducaoPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {

    }


    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderCliente = (usu_nome) => {
        return (
            <span>{usu_nome.substring(0, 15)}</span>
        );
    };

    renderProduto = (prod_descricao, registro) => {
        return (
            <span>{'[' + registro.prod_codigo + '] ' + prod_descricao}</span>
        );
    };



    render() {
        const { carregando, visualizar } = this.state;


        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Relatório de Produção
                        </div>

                        <Table
                            pagination={false}
                            dataSource={this.props.listaRegistros}
                            className="tabela"
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="pi_dt_producao"
                                dataIndex="pi_dt_producao"
                                title="Data"
                                render={this.renderData}
                                width={"12%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="lp_descricao"
                                dataIndex="lp_descricao"
                                title="Linha Pordução"
                                width={"10%"}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="op_numero"
                                dataIndex="op_numero"
                                title="Controle"
                                width={"8%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_numero"
                                dataIndex="ven_numero"
                                title="Pedido"
                                width={"8%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="prod_descricao"
                                dataIndex="prod_descricao"
                                title="Produto"
                                render={this.renderProduto}
                                width={"15%"}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="pi_qtde"
                                dataIndex="pi_qtde"
                                title="Qtde"
                                render={this.renderValor}
                                width={"10%"}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                render={this.renderCliente}
                                width={"10%"}
                                align="left"
                                className="listaCadastro"
                            />
                            {/* <Column
                                key="cmun_descricao"
                                dataIndex="cmun_descricao"
                                title="Cidade"
                                render={this.renderCidade}
                                width={"10%"}
                                align="left"
                                className="listaCadastro"
                            /> */}
                            <Column
                                key="descrStatus"
                                dataIndex="descrStatus"
                                title="Status"
                                render={this.renderStatus}
                                width={"13%"}
                                align="center"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default MonitorProducaoPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/MonitorProducaoPrintModal.js